package com.sweetlime.bingeamigo.state

sealed class AuthState {
    data object Idle : AuthState()
    data object Loading : AuthState()
    data class Success(val userId: String) : AuthState()
    data class Error(val message: String) : AuthState()
    data class PendingVerification(val email: String) : AuthState()
    data class PasswordResetSent(val email: String) : AuthState()
}